<div class="cookie-banner" *ngIf="showBanner">
  <div class="cookie-banner-content">
    <div class="cookie-banner-body">
      <nb-icon icon="shield-checkmark-outline" status="primary"></nb-icon>
      <span class="cookie-text">
        Utilizamos cookies para melhorar sua experiência. 
        <a (click)="openPoliticaCookies()" style="cursor: pointer;">Saiba mais</a>
      </span>
    </div>
    
    <div class="cookie-banner-actions">
      <button 
        nbButton 
        status="primary" 
        size="small"
        (click)="acceptCookies()"
        class="accept-btn">
        Aceitar
      </button>
      
      <button 
        nbButton 
        status="basic" 
        size="small"
        (click)="rejectCookies()"
        class="reject-btn">
        Rejeitar
      </button>
    </div>
  </div>
</div>

<!-- Modal Política de Cookies -->
<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Política de Cookies</h2>
      <button class="close-btn" (click)="closeModal()">×</button>
    </div>
    
    <div class="modal-body">
      <div class="politica-section">
        <h3>📋 O que são Cookies?</h3>
        <p>Cookies são pequenos arquivos de texto que são armazenados no seu dispositivo quando você visita nosso site. Eles nos ajudam a melhorar sua experiência, analisar o uso do site e personalizar o conteúdo.</p>
      </div>

      <div class="politica-section">
        <h3>🔍 Como Utilizamos os Cookies</h3>
        <ul>
          <li><strong>Cookies Essenciais:</strong> Necessários para o funcionamento básico do site</li>
          <li><strong>Cookies de Performance:</strong> Nos ajudam a entender como você usa nosso site</li>
          <li><strong>Cookies de Funcionalidade:</strong> Permitem funcionalidades personalizadas</li>
          <li><strong>Cookies de Marketing:</strong> Usados para mostrar conteúdo relevante</li>
        </ul>
      </div>

      <div class="politica-section">
        <h3>🛡️ Sua Privacidade</h3>
        <p>Respeitamos sua privacidade. Você pode:</p>
        <ul>
          <li>Gerenciar suas preferências de cookies a qualquer momento</li>
          <li>Excluir cookies existentes através das configurações do seu navegador</li>
          <li>Recusar cookies não essenciais sem afetar a funcionalidade básica</li>
        </ul>
      </div>

      <div class="politica-section">
        <h3>⚙️ Gerenciando Cookies</h3>
        <p>Para gerenciar cookies no seu navegador:</p>
        <ul>
          <li><strong>Chrome:</strong> Configurações > Privacidade e segurança > Cookies</li>
          <li><strong>Firefox:</strong> Opções > Privacidade e Segurança > Cookies</li>
          <li><strong>Safari:</strong> Preferências > Privacidade > Cookies</li>
          <li><strong>Edge:</strong> Configurações > Cookies e permissões do site</li>
        </ul>
      </div>

      <div class="politica-section">
        <h3>📞 Entre em Contato</h3>
        <p>Se você tiver dúvidas sobre nossa política de cookies, entre em contato conosco através do nosso suporte.</p>
      </div>

      <div class="politica-footer">
        <p><strong>Última atualização:</strong> {{ dataAtual }}</p>
      </div>
    </div>
    
    <div class="modal-footer">
      <button nbButton status="primary" (click)="closeModal()">
        ✅ Entendi
      </button>
    </div>
  </div>
</div> 